/** @format */

import React from "react";

const StoreWrapper = ({ name, children, className = "" }) => {
  return (
    <div className={`${className} w-full md:w-[45%]`}>
      <div className="flex border p-[1rem] md:p-[1.3rem] rounded-xl justify-between items-center bg-white shadow-sm hover:shadow-md transition-shadow">
        <p className="text-[1rem] md:text-[1.1rem] font-medium text-[#4b5563] m-0 pr-2 leading-tight flex-1">{name}</p>
        <div className="flex-shrink-0 flex items-center">
          {children}
        </div>
      </div>
    </div>
  );
};

export default StoreWrapper;
